var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_56620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5.64844C8.31383 5.64844 9.37891 4.58336 9.37891 3.26953C9.37891 1.9557 8.31383 0.890625 7 0.890625C5.68617 0.890625 4.62109 1.9557 4.62109 3.26953C4.62109 4.58336 5.68617 5.64844 7 5.64844Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 5.64844C12.6431 5.64844 13.3164 4.97512 13.3164 4.14453C13.3164 3.31395 12.6431 2.64062 11.8125 2.64062C10.9819 2.64062 10.3086 3.31395 10.3086 4.14453C10.3086 4.97512 10.9819 5.64844 11.8125 5.64844Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 5.64844C3.01808 5.64844 3.69141 4.97512 3.69141 4.14453C3.69141 3.31395 3.01808 2.64062 2.1875 2.64062C1.35692 2.64062 0.683594 3.31395 0.683594 4.14453C0.683594 4.97512 1.35692 5.64844 2.1875 5.64844Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66926 7.00176C3.07727 6.51674 2.54114 6.58094 1.85664 6.58094C0.832891 6.58094 0 7.40891 0 8.42637V11.4126C0 11.8545 0.360664 12.2138 0.80418 12.2138C2.71895 12.2138 2.48828 12.2484 2.48828 12.1312C2.48828 10.0151 2.23765 8.46336 3.66926 7.00176Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65187 6.59476C6.45629 6.49504 5.41709 6.59591 4.52073 7.33578C3.02074 8.53727 3.30941 10.155 3.30941 12.1341C3.30941 12.6577 3.73542 13.0916 4.26698 13.0916C10.0388 13.0916 10.2685 13.2778 10.6107 12.5199C10.723 12.2636 10.6922 12.345 10.6922 9.89297C10.6922 7.94538 9.00585 6.59476 7.65187 6.59476Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1427 6.58087C11.4545 6.58087 10.9213 6.51732 10.3301 7.00169C11.751 8.45244 11.5111 9.89835 11.5111 12.1311C11.5111 12.2491 11.3196 12.2137 13.1664 12.2137C13.6258 12.2137 13.9993 11.8415 13.9993 11.3841V8.4263C13.9993 7.40884 13.1664 6.58087 12.1427 6.58087Z",
    fill: "#current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_56620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/Modules.fa39d1669fae4c1d02a98f6f8e0150b1.svg";
export { ForwardRef as ReactComponent };